//Views
PJQ.views.prequal = {};

PJQ.views.prequal.PrequalEditor = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Editor'),
        subTemplates: {
            tab: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Tab'),
            fieldCategory: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Field-Category'),
            field: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Field'),
            fieldInput: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Field-Input'),
            otherOffice: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Other-Office'),
            contact: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Contact'),
            projectReference: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Project-Reference'),
            faq: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-FAQ'),
            nav: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Nav'),
            requestedBy: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'requested-by'),
            comments: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'prequal-comments')
        },
        tokens: {
            currentYear: PJQ.helpers.dateHelpers.getCurrentYear()
        },
        baseFaqItems: [
            {
                q: "Why am I being asked to complete this form?",
                a: "The requesting General Contractor, in an effort to improve their bidding process and ensure data consistency among their subcontractors have asked all subcontractors to keep on file updated company qualification data."
            },
            {
                q: "How often do I need to update this information?",
                a: "You have the ability to update your information at any time.  Only certain performance data will be required to updated annually as a majority of your company information may not change."
            },
            {
                q: "I've worked with the requesting General Contractor many times in the past, why am I being asked to complete this now?",
                a: "The requesting General Contractor is updating their database so that all subcontractors have current and consistent company and performance information on file regardless of previous contract awards."
            },
            {
                q: "What if I don’t know the answers to all the questions being asked?",
                a: "If you do not have the information on hand, you may return to the form once you are ready.  All of your previously entered information will remain intact."
            },
            {
                q: "I've completed every field but the form is not at 100%.",
                a: "Fields that are incomplete will be highlighted in red. Common fields that are overlooked as complete are phone number fields which require all 10 digits to be considered complete.  You can view the left hand menu to determine which section is incomplete."
            },
            {
                q: "One of our divisions/offices already filled in this information and it's all the same. Do I need to do it again?",
                a: "If you have received the request multiple times to your same email address, please contact the General Contractor as this means you have been entered twice in the address book of the General Contractor. If the requests have gone to different contacts within your company and each contact is responsible for submitting bids for their respective office/division, then yes each contact will need to fill out the form."
            }
        ],
        proqualFaqItems: [
            {
                q: "I've already completed this form for another GC, can I transfer that info to this form?",
                a: "The information you fill out for the requesting General Contractor is for their eyes only.  However if you would like to share your current information and not have to fill out the full form for another party, please <a href='http://network.panteratools.com/pantera-network-faqpath/'>click here to find out how</a>."
            },
            {
                q: "I have never received a bid or job from this GC, why should I complete this form?",
                a: "In an effort to make better subcontracting decisions and provide subcontractors with the right opportunities, the data on this form will help us get you the requests that match your specialties with our upcoming work.  Filling out this form will increase the likelihood that you will be considered for a project in the future."
            },
            {
                q: "I only want to complete this form if I'm awarded a job.",
                a: "The requesting General Contractor is utilizing the this data in addition to information provided with bids. By taking the 15 minutes to complete this now will them know who is serious about bidding."
            }
        ],
        commentsExpanded: false,
        canEdit: true,
        isAdmin: false,
        onContactChange: null,
        onCompanyCustomFieldChange: null,
        onContactCustomFieldChange: null
    },
    events: {
        'keydown .input-zip': 'allowZip',
        'keydown .input-dollars-full,.input-numeric,.input-percent': 'numbersOnly',
        'change .input-percent': 'formatPercent',
        'click .add-other-office': 'addOtherOffice',
        'click .delete-other-office': 'deleteOtherOffice',
        'click .add-owner-contact': 'addOwnerContact',
        'click .delete-owner-contact': 'deleteOwnerContact',
        'click .add-operations-contact': 'addOperationsContact',
        'click .delete-operations-contact': 'deleteOperationsContact',
        'click .add-estimating-contact': 'addEstimatingContact',
        'click .delete-estimating-contact': 'deleteEstimatingContact',
        'click .add-safety-contact': 'addSafetyContact',
        'click .delete-safety-contact': 'deleteSafetyContact',
        'click .add-project-reference': 'addProjectReference',
        'click .delete-project-reference': 'deleteProjectReference',
        'click .network-upgrade': 'networkUpgrade',
        'click .edit-profile': 'editProfile',
        'click .view-prequal-faq': 'viewFaq',
        'shown.bs.tab .prequal-nav-item': 'navClicked',
        'click .download-prequal-field-file': 'downloadFieldFile',
        'click .prequal-tab-next': 'nextTab',
        'click .prequal-tab-previous': 'previousTab',
        //todo: remove this once prequal is moved to dialog on screenings page
        'click .btn-continue': "continue"
    },
    beforeFirstRender: function () {
        if (this.model.contact != null) {
            this.model.contact.attributes.contactCustomFieldValues = null;
            this.model.contact.attributes.companyCustomFieldValues = null;
        }

        this.clients = this.options.clients;

        this.listenTo(this.model, "fetch", this.render);

        let $pru = $('.prequal-request-update');
        $pru.off();
        $pru.on('click', _.bind(this.requestUpdate, this));
    },
    beforeRender: function () {
        this.options.canEdit = this.options.canEdit && (this.options.isAdmin || !this.model.get('isLocked'));
    },
    requestUpdate: function () {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.model.contact.id
                },
                {
                    endpoint: 'prequal'
                },
                {
                    endpoint: 'request'
                }
            ])
        }).post().done(_.bind(function (data) {
            if (data && data.success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Prequalification update sent'
                });
                $('.prequal-request-update').html('<i class="fal fa-check mr-1"></i>Update Sent').prop('disabled', true);
                this.model.set({
                    lastRequestedBy: PJQ.app.session.user.toJSON(),
                    lastRequestedOn: new Date()
                }, {silent: true});
                this.renderRequestedBy();
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'Qualification update failed, invalid email address on contact'
                });
            }
        }, this)).fail(function (xhr, err, result) {
            new PJQ.logging.Debug(PJQ.logging.LoggingActions.SEND_PREQUAL_UPDATE, {
                error: err,
                result: result
            });
        });
    },
    renderData: function () {
        return {
            model: this.model,
            renderTokens: _.bind(this.renderTokens, this),
            isAdmin: this.options.isAdmin
        };
    },
    afterRender: function () {
        if (this.model.id > 0) {
            this.renderNav(_.bind(function () {
                if (this.model.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PREQUAL_COMMENTS) && PJQ.app.session.hasPermission('prequal.canViewComments')) {
                    this.renderComments();
                }
                this.renderForm();
                this.$nav.animateCSS('slideDown');
                this.$('.prequal-form-container').animateCSS('fadeIn');
            }, this));
        } else {
            new PJQ.Loader(this.$('.prequal-loader'), {
                type: 'block'
            });
        }
    },
    renderComments: function () {
        this.$comments = this.options.navContainer.parent().find('.comments-outer');
        this.$comments.removeClass('hidden');
        if (!PJQ.app.session.hasPermission('prequal.canAddComments')) {
            this.$comments.find('.btn-add-comment').addClass('hidden');
        } else {
            this.$comments.find('.btn-add-comment').off().on('click', _.bind(this.addComment, this));
        }
        this.renderSubTemplate(false, this.options.subTemplates.comments, this.$comments.find('.prequal-comments'), {
            comments: this.model.comments.models,
            expand: this.options.commentsExpanded,
            canDelete: PJQ.app.session.hasPermission('prequal.canDeleteComments')
        }, _.bind(function ($comm) {
            $comm.find('.btn-expand-comments').on('click', _.bind(this.expandComments, this));
            $comm.find('.btn-delete-comment').off().on('click', _.bind(this.deleteComment, this));
        }, this));
    },
    addComment: function () {
        new PJQ.views.comments.CommentsModal({
            onAddComment: _.bind(function (commentText) {
                let newComment = new PJQ.models.prequal.Comment({
                    contactCompanyId: this.model.get('contactCompanyId'),
                    commentText: commentText,
                    masterUserId: this.model.get('masterUserId')
                });
                newComment.save(null, {
                    success: _.bind(function () {
                        this.model.comments.add(newComment);
                        this.renderComments();
                    }, this)
                });
            }, this)
        });
    },
    expandComments: function () {
        this.options.commentsExpanded = true;
        this.$comments.find('.expand-comments-outer').remove();
        this.$comments.find('.comments-extra').animateCSS('slideDown');
    },
    deleteComment: function(e) {
        let target = $(e.currentTarget),
            $comment = target.closest('.card'),
            cid = $comment.data().cid,
            comment = this.model.comments.get(cid);

        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this comment?",
            onDelete: _.bind(function () {
                this.model.comments.remove(comment);
                comment.destroy();
                this.renderComments();
            }, this)
        });
    },
    renderNav: function (callback) {
        if (this.$nav != null) {
            this.$nav.remove();
            this.$nav = null;
        }

        this.$nav = $('<div>', {
            class: 'prequal-nav-container hidden'
        });
        this.addElements(this.$nav);
        this.options.navContainer.prepend(this.$nav);
        this.renderSubTemplate(true, this.options.subTemplates.nav, this.$nav, {
            model: this.model,
            options: this.options,
            renderTokens: _.bind(this.renderTokens, this)
        }, _.bind(function () {
            this.$nav.find('.btn-unlock').off().on('click', _.bind(this.unlockPrequal, this));
            this.$nav.find('.btn-lock').off().on('click', _.bind(this.lockPrequal, this));
            this.$nav.find('.prequal-nav-item').on('shown.bs.tab', _.bind(this.navClicked, this));
            this.renderRequestedBy();
            callback();
        }, this));
    },
    renderRequestedBy: function () {
        this.renderSubTemplate(false, this.options.subTemplates.requestedBy, this.$nav.find('.requested-by'), {
            model: this.model,
            isAdmin: this.options.isAdmin
        });
    },
    renderForm: function () {
        this.$('.prequal-header').empty();
        this.$('.prequal-tabs').empty();
        this.contactsGridsAutcompletes = null;

        let headerPref = this.model.preferences.getPref(PJQ.constants.preferenceTypes.PREQUAL_HEADER);
        if (_.size(headerPref) > 0) {
            new PJQ.Alert(this.$('.prequal-header'), {
                text: headerPref,
                isPrepend: true,
                type: 'warning'
            });
        }

        if (!this.options.isAdmin) {
            let alertCookie = null, alertType, helpAlertText;
            if (this.model.get('isLocked')) {
                alertType = 'warning';
                helpAlertText = 'Your prequalification form is currently locked and cannot be changed until it is unlocked by the client'
            } else {
                alertType = 'primary';
                alertCookie = PJQ.constants.cookies.CLOSE_PREQUAL_HELP_ALERT;
                helpAlertText = 'Thank you for updating your Qualification Statement. Please refer to the <a href="javascript:void(0)" class="view-prequal-faq font-weight-normal">FAQ</a> found to the left for additional details.'
                if (this.clients.hasItems()) {
                    helpAlertText += '<br /><b>Click "View Requested Criteria" after completing this form.</b>';
                } else if (this.model.get('isRequireSignature')) {
                    let sigAlertPref = this.model.preferences.getPref(PJQ.constants.preferenceTypes.PREQUAL_SIGNATURE_ALERT);
                    if (_.size(sigAlertPref) > 0) {
                        helpAlertText = sigAlertPref;
                    } else {
                        helpAlertText += '<br /><b>Click "Sign and Submit" after completing this form.</b>';
                    }
                }
            }
            new PJQ.Alert(this.$('.prequal-header'), {
                text: helpAlertText,
                type: alertType,
                isPrepend: true,
                cookie: alertCookie
            });

            if (this.options.navContainer != null) {
                this.options.navContainer.parent().find('.btn-export-prequal').animateCSS('slideDown');
            }
        }

        if (this.options.isAdmin) {
            let dp = new PJQ.inputs.Datepicker({
                el: this.$nav.find('.edit-expiration'),
                isShowTimezone: false,
                datePickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    widgetPositioning: {
                        vertical: 'bottom',
                        horizontal: 'auto'
                    },
                    defaultDate: this.model.get('expiresOn')
                },
                onChange: _.bind(function (expiresOn) {
                    this.model.patch({
                        expiresOn: expiresOn
                    });
                    this.renderExpiration();
                    dp.hide();
                }, this)
            });
        }
        this.renderExpiration();

        if (this.model.get('isRequireSignature')) {
            this.renderSigned();
        }

        //Render all of the tabs
        this.formulaFields = {};
        this.tabChanged();

        this.fillDefaults();

        _.each(_.sortBy(_.filter(this.model.tabs, function (tab) {
            let tabFields = _.filter(tab.fields, function (field) {
                if (field.isHidden || (field.isAdmin && !this.options.isAdmin)) {
                    return false;
                }

                if (this.options.isAdmin && _.size(field.allowedUserTypeIds) > 0) {
                    return field.allowedUserTypeIds.indexOf(PJQ.app.session.user.get('userTypeId')) !== -1;
                }

                return true;
            }, this);
            return _.size(tabFields) > 0 && !tab.isHidden
        }, this), function (tab) {
            return tab.sortOrder
        }), _.bind(function (tab, index) {
            this.renderSubTemplate(true, this.options.subTemplates.tab, this.$('.prequal-tabs'), {
                index: index,
                tab: tab
            });

            let tabEl = this.getTabElement(tab.prequalTabId);
            if (_.size(tab.note) > 0) {
                new PJQ.Alert(tabEl, {
                    text: tab.note,
                    isPrepend: true
                });
            }

            //Render all of the fields for this tab
            _.each(_.sortBy(tab.fields, function (field) {
                return field.sortOrder;
            }), _.bind(function (field) {
                let fnParsed = this.parseFormula(field);
                if (_.size(fnParsed.args) > 0) {
                    _.each(fnParsed.args, function (arg) {
                        if (arg != null && arg.indexOf('[') !== -1) {
                            let cfId = parseInt(arg.replace('[', '').replace(']', ''));
                            this.formulaFields[cfId] = _.uniq(_.union(this.formulaFields[cfId], [field.prequalFieldId]));
                        }
                    }, this);
                }

                // don't render the field, but we want to add it as a formula field above
                if (field.isHidden || (field.isAdmin && !this.options.isAdmin)
                    || (this.options.isAdmin && _.size(field.allowedUserTypeIds) > 0 && field.allowedUserTypeIds.indexOf(PJQ.app.session.user.get('userTypeId')) === -1)) {
                    return;
                }

                let fieldDestination = tabEl;
                if (field.category.length > 0) {
                    let categoryId = this.model.categories.indexOf(field.category);
                    if (categoryId < 0) {
                        this.model.categories.push(field.category);
                        categoryId = this.model.categories.indexOf(field.category);
                    }
                    if (this.getCategoryElement(tab.prequalTabId, categoryId).length === 0) {
                        this.renderSubTemplate(true, this.options.subTemplates.fieldCategory, fieldDestination, {
                            category: this.renderTokens(field.category),
                            categoryId: categoryId
                        });
                    }
                    fieldDestination = this.getCategoryElement(tab.prequalTabId, categoryId);
                }

                let overrideCanEdit = false;
                if (!this.options.canEdit && _.size(field.adminUserTypeIds) > 0 && field.adminUserTypeIds.indexOf(PJQ.app.session.user.get('userTypeId')) !== -1) {
                    overrideCanEdit = true;
                }

                // If the user has changed the amount of project references required, we need to replace any reference to 3 (default value) to the new required amount.
                if (field.coreFieldName.toLowerCase() === 'projectreferences' && this.model.preferences.hasPref(PJQ.constants.preferenceTypes.PREQUAL_PROJECT_REFERENCE_COUNT)) {
                    let refCount = this.model.preferences.getPref(PJQ.constants.preferenceTypes.PREQUAL_PROJECT_REFERENCE_COUNT);
                    field.description = field.description.replace("three (3)", (PJQ.helpers.formatHelpers.numberToWords(refCount)) + ' (' + (refCount) + ')').replace("3", refCount);
                }

                this.renderSubTemplate(true, this.options.subTemplates.field, fieldDestination, {
                    field: field,
                    isAdmin: this.options.isAdmin === true,
                    subTemplates: this.options.subTemplates,
                    renderTokens: _.bind(this.renderTokens, this),
                    canEdit: this.options.canEdit || overrideCanEdit
                });

                if (field.coreFieldName.toLowerCase() === 'federaltaxid' && this.model.preferences.hasPref(PJQ.constants.preferenceTypes.PREQUAL_TAX_ID_MASK)) {
                    $(fieldDestination).find('input[data-p-bind="federalTaxId"]').inputmask(this.model.preferences.getPref(PJQ.constants.preferenceTypes.PREQUAL_TAX_ID_MASK), {
                        placeholder: ''
                    });
                }

                if (field.coreFieldName.toLowerCase() === 'otheroffices')
                    this.renderOtherOffices(field);
                else if (field.coreFieldName.toLowerCase() === 'ownercontacts')
                    this.renderOwnerContacts(field);
                else if (field.coreFieldName.toLowerCase() === 'operationscontacts')
                    this.renderOperationsContacts(field);
                else if (field.coreFieldName.toLowerCase() === 'estimatingcontacts')
                    this.renderEstimatingContacts(field);
                else if (field.coreFieldName.toLowerCase() === 'safetycontacts')
                    this.renderSafetyContacts(field);
                else if (field.coreFieldName.toLowerCase() === 'projectreferences')
                    this.renderProjectReferences(field);
            }, this));
        }, this));
        this.renderGroups();
        this.renderRegions();
        this.attachFormEvents();
        this.updateCalcFields();
        this.updateFormulaFields();
        this.validateForm();
        if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DODGE_CRM) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DODGE_WG)) {
            this.$('.network-upgrade,.edit-profile').removeClass('hidden');
        }
        this.updateLastSavedDate();

        //Update the prequal form percent complete on first load - we want to be sure this is up to date in the database as much as possible
        this.model.patch({
            percentComplete: this.model.get('percentComplete'),
            masterUserId: this.model.get('masterUserId')
        });
    },
    renderExpiration: function () {
        let expiresOn = this.model.get('expiresOn'),
            $expiresOn = this.$nav.find('.prequal-expires-on');
        if (expiresOn != null) {
            let expiresOnDate = new Date(expiresOn);
            $expiresOn.text(PJQ.helpers.dateHelpers.getDateString(expiresOnDate, PJQ.helpers.dateHelpers.dateFormats.DATE)).css({
                color: PJQ.helpers.dateHelpers.checkDateIsBeforeToday(expiresOnDate) ? PJQ.constants.colors.RED : PJQ.constants.colors.GREEN
            });
        } else {
            $expiresOn.text("Not Set").css({
                color: PJQ.constants.colors.RED
            });
        }
    },
    renderSigned: function () {
        let signedOn = this.model.get('signedOn'),
            $signedOn = this.$nav.find('.prequal-signed-on');
        if (signedOn != null) {
            $signedOn.text(PJQ.helpers.dateHelpers.getDateString(new Date(signedOn), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME)).css({
                color: PJQ.constants.colors.GREEN
            });
        } else {
            $signedOn.text("Never").css({
                color: PJQ.constants.colors.RED
            });
        }
    },
    continue: function () {
        let requireSignature = this.model.get('isRequireSignature'),
            hasScreenings = this.clients.hasItems();
        if (requireSignature) {
            let terms = this.model.preferences.getPref(PJQ.constants.preferenceTypes.PREQUAL_TERMS),
                onSubmit = _.bind(function (signature, callback) {
                    this.model.sign(signature, _.bind(function () {
                        if (hasScreenings) {
                            this.viewScreenings();
                            this.renderSigned();
                        } else if (this.model.get('isLocked')) {
                            this.render();
                        } else {
                            this.renderSigned();
                        }
                        PJQ.notifications.notify.successNotify({
                            message: 'Qualification Statement signed'
                        });
                        callback();
                    }, this));
                }, this);
            if (terms != null) {
                new PJQ.views.signatures.SignatureTermsModal({
                    terms: terms,
                    onSubmit: onSubmit,
                    fitHeight: false
                });
            } else {
                new PJQ.views.signatures.SignatureSubmitModal({
                    onSubmit: onSubmit
                });
            }
        } else if (hasScreenings) {
            this.viewScreenings();
        }
    },
    viewScreenings: function () {
        let fnView = _.bind(function () {
            if (this.options.dashboard) {
                this.options.dashboard.renderClientScreenings();
            } else {
                window.location = (window.location.href.toLowerCase().substring(0, window.location.href.toLowerCase().indexOf('&')) + '&sId=' + pjqScreeningAccessKey);
            }
        }, this);
        if (_.size(this.model.dirtyAttributes) > 0) {
            this.model.patch({
                prequalCoreId: this.model.id,
                masterUserId: this.model.get('masterUserId')
            }, {
                success: _.bind(function () {
                    fnView();
                }, this)
            });
        } else {
            fnView();
        }
    },
    updateViewScreeningButton() {
        let requireSignature = this.model.get('isRequireSignature');
        if (requireSignature) {
            let screeningButton = this.$('.btn-continue'),
                allowSignatureAlways = this.model.preferences.getPref(PJQ.constants.preferenceTypes.PREQUAL_ALLOW_SIGNATURE_ALWAYS);
            screeningButton.removeClass('hidden');
            if (this.model.get("percentComplete") < 100 && !allowSignatureAlways) {
                screeningButton.prop('disabled', true);
            } else {
                screeningButton.prop('disabled', false);
            }

            screeningButton.text("Sign and Submit");
        }
    },
    attachFormEvents: function () {
        let self = this;
        this.selectPickers = {};
        //Init select inputs and attach events
        this.$('.input-select[data-p-bind],.input-bool[data-p-bind]').each(function () {
            let input = $(this),
                fieldId = input.data('fieldId'),
                field = self.model.fields[fieldId],
                attribute = input.data('pBind') ? input.data('pBind') : '',
                isContactInput = attribute.indexOf('contact.') !== -1,
                isABCustomField = attribute.indexOf('contact.cf_') !== -1 || attribute.indexOf('contact.ccf_') !== -1,
                selectPicker = new PJQ.inputs.Selectpicker({
                    el: input,
                    isIntChoices: !input.hasClass('input-bool') && !input.hasClass('input-state') && (isABCustomField || !isContactInput) && attribute.toLowerCase() !== 'isunion|isnonunion',
                    exclusiveChoices: _.map(_.where(field.choices, {isExclusive: true}), function (choice) {
                        return choice.prequalFieldChoiceId;
                    }),
                    onChange: function (value) {
                        if (input.hasClass('input-bool')) {
                            if (_.size(value) > 0) {
                                value = value.toLowerCase() === 'true';
                            } else {
                                value = null;
                            }
                        }

                        //Custom logic for contact state/country
                        if (isContactInput) {
                            if (attribute.toLowerCase() === 'contact.country') {
                                self.renderContactStateCountyPickers(value);
                            }
                        }

                        self.prequalChanged(input, value);
                    }
                });

            if (attribute.toLowerCase() === 'contact.state') {
                self.contactStatePicker = selectPicker;
            } else {
                let fieldId = input.data('fieldId');
                self.selectPickers[fieldId] = selectPicker;
            }
        });
        this.renderContactStateCountyPickers(this.model.contact.get('country'));

        this.$('.input-date[data-p-bind],.input-date-time[data-p-bind]').each(function () {
            let fieldEl = $(this),
                isDateTime = $(this).hasClass('.input-date-time');
            new PJQ.inputs.Datepicker({
                el: fieldEl,
                datepickerOptions: {
                    format: !isDateTime ? PJQ.helpers.dateHelpers.dateFormats.DATE.toUpperCase() : undefined
                },
                onChange: function (value) {
                    self.prequalChanged(fieldEl, value);
                }
            });
        });

        this.$('.input-file-upload').each(function () {
            let $input = $(this),
                field = self.model.fields[$input.data('fieldId')],
                fnInput = function (attachments) {
                    let endpoint,
                        screeningItemId = field.relatedScreeningItemId;
                    if (screeningItemId > 0) {
                        endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                                {
                                    endpoint: 'contacts',
                                    value: self.options.contact != null ? self.options.contact.id : PJQ.app.session.contact.id
                                },
                                {
                                    endpoint: 'screenings'
                                },
                                {
                                    endpoint: 'items',
                                    value: screeningItemId
                                },
                                {
                                    endpoint: 'attachments'
                                }
                            ],
                            [
                                {
                                    parameter: 'masterUserId',
                                    value: self.model.get('masterUserId')
                                }
                            ]);
                    } else {
                        let params;
                        if (self.model.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PREQUAL_CONTACT_ATTACHMENT_LINK)) {
                            params = [
                                {
                                    parameter: 'fromPrequal',
                                    value: true
                                }
                            ];
                        } else {
                            params = null
                        }

                        endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'contacts',
                                value: self.options.contact != null ? self.options.contact.id : PJQ.app.session.contact.id
                            },
                            {
                                endpoint: 'attachments'
                            }
                        ], params);
                    }

                    let overrideCanEdit = false;
                    if (!self.options.canEdit && _.size(field.adminUserTypeIds) > 0 && field.adminUserTypeIds.indexOf(PJQ.app.session.user.get('userTypeId')) !== -1) {
                        overrideCanEdit = true;
                    }
                    new PJQ.views.files.FileUploaderGrid({
                        el: $input,
                        canUpload: (self.options.canEdit || overrideCanEdit),
                        canDelete: !(screeningItemId > 0) && (self.options.canEdit || overrideCanEdit) && (self.options.isAdmin || overrideCanEdit || !self.model.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PREQUAL_ATTACHMENT_DELETE)),
                        collection: attachments,
                        endpoint: endpoint,
                        onSuccess: function (file) {
                            if (!(screeningItemId > 0)) {
                                let guids = [file.guid];
                                if (attachments != null) {
                                    _.each(attachments.models, function (attachment) {
                                        if (_.size(attachment.get('guid')) > 0) {
                                            guids.push(attachment.get('guid'));
                                        }
                                    });
                                }
                                self.prequalChanged($input, guids);
                            } else if (file.fileData != null) {
                                let fieldId = $input.data('fieldId'),
                                    tab = self.getFieldTab(fieldId),
                                    field = _.findWhere(tab.fields, {
                                        prequalFieldId: fieldId
                                    });
                                if (field != null) {
                                    field.isValid = true;
                                    self.prequalChanged($input, field.fieldValue);
                                }
                            }
                        },
                        onDelete: function (file, callback) {
                            let guids = [],
                                delAttachments = [];
                            if (attachments != null) {
                                _.each(attachments.models, function (attachment) {
                                    if (_.size(attachment.get('guid')) > 0 && file.get('guid') !== attachment.get('guid')) {
                                        guids.push(attachment.get('guid'));
                                    } else {
                                        delAttachments.push(attachment);
                                    }
                                });
                                attachments.remove(delAttachments);
                            }
                            self.prequalChanged($input, guids);
                            callback();
                        }
                    });
                };
            if (_.size(field.fieldValue) > 0) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'files'
                        },
                        {
                            endpoint: 'details'
                        }
                    ]),
                    data: {
                        guids: field.fieldValue ? ((typeof field.fieldValue === 'string') ? field.fieldValue.split('|') : field.fieldValue) : null
                    }
                }).post().done(_.bind(function (result) {
                    let attachments = new PJQ.collections.files.Files(result);
                    fnInput(attachments);
                }, this));
            } else {
                fnInput(new PJQ.collections.files.Files());
            }
        });

        //Init the binder but override the change event
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ],
            onChange: _.bind(function (changeEl, attribute, value) {
                this.prequalChanged(changeEl, value);
            }, this)
        });

        this.$('.input-dollars-full[data-p-bind],.input-numeric[data-p-bind],.input-percent[data-p-bind]').each(function () {
            let input = $(this),
                field = self.model.fields[input.data('fieldId')];

            if (field.numericMinValue != null || field.numericMaxValue != null) {
                PJQ.helpers.inputHelpers.attachNumericInputMinMax(input, field.numericMinValue, field.numericMaxValue, function () {
                    input.trigger('keyup');
                });
            }
        });
        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2);
        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-phone'));
    },
    renderContactStateCountyPickers: function (country) {
        let states = PJQ.constants.states.us;
        if (country.toLowerCase() === 'ca') {
            states = PJQ.constants.states.ca;
        }
        if (this.contactStatePicker) {
            this.contactStatePicker.updateChoices(_.union([""], _.map(states, function (state) {
                return state.abbreviation;
            })));
            this.contactStatePicker.setValue(this.model.contact.get('state'));
        }
    },
    getNewDateAddMonths: function (date, months) {
        if (date == null) {
            return null;
        }

        let dt = new Date(date);
        if (months > 0) {
            return new moment(dt).add(months, 'months').format('MM/DD/YYYY');
        } else {
            return new moment(dt).format('MM/DD/YYYY');
        }
    },
    checkFieldValueChanged: function (fieldType, currentValue, newValue) {
        let hasChanged;
        switch (fieldType.toLowerCase()) {
            case 'int':
            case 'money':
            case 'percent':
            case 'state':
            case 'text':
            case 'textarea':
            case 'phone':
            case 'bool':
                hasChanged = currentValue == null || currentValue !== newValue;
                break;
            case 'choice':
            case 'upload':
            case 'date':
            case 'grid':
            case 'groupselect':
            case 'regionselect':
            default:
                // any change event on these fields is assumed to be a data change
                hasChanged = true;
                break;
        }
        return hasChanged;
    },
    prequalChanged: function (input, value, fId = null, isUpdate = true) {
        let attribute, fieldId;
        if (fId > 0) {
            fieldId = fId;
            if (_.size(input) === 0) {
                input = this.getFieldElement(fieldId);
            }
        } else {
            fieldId = input.data('fieldId');
        }

        let tab = this.getFieldTab(fieldId);
        if (tab == null) {
            return;
        }

        let field = _.findWhere(tab.fields, {
                prequalFieldId: fieldId
            }),
            fieldType = field.fieldType.toLowerCase();

        if (_.size(input) > 0) {
            attribute = input.data('pBind');
        } else if (field != null) {
            if (field.fieldNumber > 0) {
                attribute = "cf_" + field.fieldNumber.toString();
            } else if (_.size(field.coreFieldName) > 0) {
                attribute = field.coreFieldName.toLowerCase();
            }
        }

        if (_.size(attribute) === 0 || fieldId == null) {
            if(tab && field) {
                this.queueValidation(tab, field, isUpdate);
            }
            return;
        }

        if (fieldType === "percent" && value > 0) {
            value = value / 100;
        }

        value = value != null ? value : "";

        //Check if the changed value is for a grid field - if its a grid the attribute will be null
        if (attribute != null) {
            if (this.model.attributes.patchValues == null) {
                this.model.attributes.patchValues = [];
            }

            //Check if the changed value is for a custom field
            if (attribute.indexOf('cf_') > -1) {
                let fnParse = this.parseFormula(field);
                if (typeof fnParse.fn === 'function' && (value == null || _.size(value.toString()) === 0)) {
                    let valArgs = [];
                    _.each(fnParse.args, function (arg) {
                        if (arg != null) {
                            if (arg.indexOf('[') !== -1) {
                                let argId = arg.replace('[', '').replace(']', ''),
                                    argField = this.model.fields[parseInt(argId)];
                                if (argField != null) {
                                    if (argField.fieldType.toLowerCase() === 'bool') {
                                        valArgs.push(argField.fieldValue != null ? argField.fieldValue : '');
                                    } else {
                                        valArgs.push(argField.fieldValue != null ? argField.fieldValue : 0);
                                    }
                                }
                            } else {
                                valArgs.push(arg);
                            }
                        }
                    }, this);
                    value = fnParse.fn(...valArgs);

                    let displayValue;
                    if (value != null && typeof value === 'object' && typeof value.display !== 'undefined') {
                        displayValue = value.display;
                        value = value.value;
                    } else {
                        displayValue = value;
                    }

                    if (fieldType === 'bool' || fieldType === 'choice') {
                        let sp = this.selectPickers[fieldId];
                        if (sp != null) {
                            sp.setValue(displayValue);
                        }
                    } else if (_.size(input) > 0) {
                        let inputVal = displayValue;
                        if (fieldType === 'money') {
                            inputVal = displayValue != null ? parseFloat(displayValue / 100) : '';
                        } else if (fieldType === 'date' || fieldType === 'datetime') {
                            let dateFormat = fieldType === 'date' ? PJQ.helpers.dateHelpers.dateFormats.DATE : PJQ.helpers.dateHelpers.dateFormats.DATE_TIME;
                            inputVal = displayValue != null ? PJQ.helpers.dateHelpers.getDateString(inputVal, dateFormat) : '';
                        }
                        input.val(inputVal);
                    }
                } else if (_.size(fnParse.eval) > 0) {
                    let evl = fnParse.eval;
                    _.each(fnParse.args, function (arg) {
                        if (arg.indexOf('[') !== -1) {
                            let argId = parseInt(arg.replace('[', '').replace(']', '')),
                                fieldTab = this.getFieldTab(argId);
                            if (fieldTab != null) {
                                let argField = _.findWhere(fieldTab.fields, {
                                    prequalFieldId: argId
                                });
                                if (argField != null) {
                                    let flVal = parseFloat(argField.fieldValue);
                                    evl = evl.replace(arg, '(' + (isNaN(flVal) ? 0 : flVal) + ')');
                                }
                            }
                        }
                    }, this);
                    let evalVal = eval(evl);
                    value = isNaN(evalVal) ? 0 : evalVal;

                    if (_.size(input) > 0) {
                        input.val(field.fieldType.toLowerCase() === 'money' ? parseFloat(value / 100) : value);
                    }
                }

                field.fieldValue = value
                let customFields = {};
                if (attribute.indexOf('contact.ccf_') > -1) {
                    let fieldId = parseInt(attribute.replace('contact.ccf_', '')),
                        newValue = {
                            id: fieldId,
                            prequalFieldId: field.prequalFieldId,
                            value: value
                        },
                        currentValue = _.find(this.model.get('companyCustomFieldValues'), function (exValue) {
                            return newValue.id === exValue.id;
                        });
                    if (currentValue != null) {
                        if (!this.checkFieldValueChanged(field.fieldType, currentValue.value, newValue.value)) {
                            return;
                        }
                    }
                    if (typeof this.options.onCompanyCustomFieldChange === 'function') {
                        this.options.onCompanyCustomFieldChange(newValue);
                    }

                    let cfValues = _.filter(this.model.get('companyCustomFieldValues'), function (exValue) {
                        return newValue.id !== exValue.id;
                    });
                    cfValues.push(newValue);
                    this.model.set('companyCustomFieldValues', cfValues);

                    if (this.model.contact != null) {
                        this.model.contact.set('companyCustomFieldValues', cfValues, {silent: true});
                    }
                } else {
                    let customFieldNumber = parseInt(attribute.replace('cf_', ''));
                    if (customFields[customFieldNumber] !== value) {
                        customFields[customFieldNumber] = value;
                        this.model.set('customFieldValues', _.defaults(customFields, this.model.dirtyAttributes.customFieldValues));
                    }
                }

                let calcIds = this.formulaFields[field.prequalFieldId];
                if (_.size(calcIds) > 0) {
                    _.each(calcIds, function (calcId) {
                        if (calcId !== fieldId) {
                            this.prequalChanged(null, null, calcId, isUpdate);
                        }
                    }, this);
                }
            }
            //Check if the changed value is for a contact field
            else if (attribute.indexOf('contact.') > -1) {
                let prop = PJQ.helpers.formatHelpers.lowerCaseFirstLetter(attribute.replace('contact.', ''));
                this.model.contact.set(prop, value);
                this.model.contact.queueSave({}, {}, 800);
                if (typeof this.options.onContactChange === 'function') {
                    this.options.onContactChange(this.model.contact, {
                        prop: prop,
                        value: value
                    });
                }
            }
            //If its not a contact or grid field, then its a prequal core/custom field
            else {
                //Check if the changed value is labor status, if it is set isUnion/isNonUnion accordingly
                if (attribute.toLowerCase() === 'isunion|isnonunion') {
                    let isUnion = _.find(value, function (choice) {
                            return choice.toLowerCase() === 'union';
                        }) != null,
                        isNonUnion = _.find(value, function (choice) {
                            return choice.toLowerCase() === 'non-union';
                        }) != null,
                        laborStatus = {
                            isUnion: isUnion,
                            isNonUnion: isNonUnion
                        };
                    this.model.contact.set(laborStatus);
                    this.model.contact.queueSave({}, {}, 800);
                    if (typeof this.options.onContactChange === 'function') {
                        this.options.onContactChange(this.model.contact, {
                            prop: 'isUnion',
                            value: isUnion
                        });
                        this.options.onContactChange(this.model.contact, {
                            prop: 'isNonUnion',
                            value: isNonUnion
                        });
                    }

                    this.model.set(laborStatus);
                } else {
                    //Set the value for the core model
                    this.model.set(attribute, value);

                    // we are only using the patchValues property for boolean and choice at the moment
                    // it works for every type of value, but has not been tested for production on anything but boolean and choice
                    // this is to fix the issue where the API doesnt know that a boolean or choice value has been updated to null
                    // the API expects that supplying null in the request model means that the value was not updated
                    if (fieldType === 'bool') {
                        value = typeof value === 'boolean' ? value : "";
                        if (typeof value === 'string' && _.size(value) > 0) {
                            value = value.toLowerCase() === 'true';
                        } else if (typeof value !== 'boolean') {
                            value = null;
                        }

                        this.model.addPatchValue({
                            attribute: attribute,
                            value: value
                        });
                    } else if (fieldType === 'choice' && value == null) {
                        this.model.addPatchValue({
                            attribute: attribute,
                            value: _.size(value) > 0 || typeof value === 'number' ? value : null
                        });
                    }
                }
            }

            // We must now apply the same value as above to the field and tab structure which is used for easier rendering and validating
            field.fieldValue = value;

            //It is a custom field
            if (field.fieldNumber > 0) {
                if (field.fieldType.toLowerCase() === 'int') {
                    this.updateCalcFields(field);
                }
            }
        } else {
            //If the attribute is null, it could be one of the grids
            if (_.size(field.coreFieldName) > 0) {
                if (field.fieldType.toLowerCase() === 'grid' && field.coreFieldName.toLowerCase().indexOf("contact") !== -1) {
                    this.renderContactsGridsAutocompletes();
                }
            }
        }

        this.queueValidation(tab, field, isUpdate);
    },
    parseFormula: function (field) {
        let result = {
            fn: null,
            eval: null,
            args: null
        };
        if (_.size(field.formula) > 0) {
            if (field.formula.indexOf('eval_') !== -1) {
                result.args = [];
                field.formula.replace(/\[(.*?)\]/g, function (g0, g1) {
                    result.args.push('[' + g1 + ']');
                });
                result.eval = field.formula.replace('eval_', '');
            } else {
                let sp = field.formula.split('(');
                if (_.size(sp) === 2) {
                    if (field.formula.indexOf('fn_') !== -1) {
                        if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'portal', 'customization', 'prequal', 'formulas')) {
                            result.fn = PJQ.app.portal.customization.prequal.formulas[sp[0].replace('fn_', '')];
                        } else {
                            result.fn = _.noop;
                        }
                    } else if (field.formula.indexOf('monthadd_') !== -1) {
                        result.fn = this.getNewDateAddMonths;
                    } else if (field.formula.indexOf('helper_') !== -1) {
                        result.fn = PJQ.helpers.prequalHelpers[sp[0].replace('helper_', '')];
                    }
                    if (typeof result.fn === 'function') {
                        result.args = sp[1].replace(')', '').replace(/\s/g, '').split(',');
                    }
                }
            }
        }
        return result;
    },
    queueValidation: function (tab, field, isUpdate = true) {
        //Set a timeout for validation
        //if a user is inputting data in a text field, this will execute on keyup and that is too much for the browser to handle
        clearTimeout(this.validateTimeout);
        this.validateQueue = this.validateQueue != null ? this.validateQueue : [];
        if (_.findWhere(this.validateQueue, {
            prequalTabId: tab.prequalTabId,
            prequalFieldId: field ? field.prequalFieldId : null
        }) == null)
            this.validateQueue.push({
                tab: tab,
                field: field
            });
        this.validateTimeout = setTimeout(_.bind(function () {
            _.each(this.validateQueue, _.bind(function (queueItem) {
                this.validateForm(queueItem.tab, queueItem.field);
            }, this));
            this.validateQueue = [];

            this.model.queueSave({
                prequalCoreId: this.model.id,
                masterUserId: this.model.get('masterUserId')
            }, {
                isPatch: true,
                success: _.bind(function () {
                    if (isUpdate) {
                        this.model.set('modifiedOn', new Date(), {silent: true});
                        this.updateLastSavedDate();
                    }
                }, this)
            }, 800);
        }, this), 300);
    },
    validateForm: function (inputTab, inputField) {
        //validates the form, calculates its completion, and renders field constraints
        this.model.completionData = this.model.completionData ? this.model.completionData : {};
        if (this.validationData == null) {
            this.validationData = {
                tabs: {},
                progress: 0
            };
        }
        _.each(_.filter(this.model.tabs, function (filterTab) {
            if (inputTab == null || (inputTab.prequalTabId === filterTab.prequalTabId && !filterTab.isHidden)) {
                return null != _.find(filterTab.fields, function (filterField) {
                    if (filterField.isAdmin && !this.options.isAdmin) {
                        return false;
                    } else if (this.options.isAdmin && _.size(filterField.allowedUserTypeIds) > 0) {
                        return filterField.allowedUserTypeIds.indexOf(PJQ.app.session.user.get('userTypeId')) !== -1;
                    }
                    return true;
                }, this);
            }
        }, this), _.bind(function (tabObj) {
            if (this.validationData.tabs[tabObj.prequalTabId] == null) {
                this.validationData.tabs[tabObj.prequalTabId] = {
                    fields: {},
                    tab: tabObj,
                    progress: 0,
                    isCalculate: tabObj.isCalculate
                }
            }
            let validationTab = this.validationData.tabs[tabObj.prequalTabId];
            _.each(_.filter(tabObj.fields, function (field) {
                return inputField == null || inputField.prequalFieldId === field.prequalFieldId;
            }, this), _.bind(function (field) {
                if (!field.isHidden && field.isRequired) {
                    if (!this.model.checkConstraintsMet(field)) {
                        validationTab.fields = _.omit(validationTab.fields, function (omitField) {
                            return omitField.field.prequalFieldId === field.prequalFieldId;
                        });
                    } else {
                        validationTab.fields[field.prequalFieldId] = {
                            field: field,
                            isValid: this.validateField(tabObj, field),
                            isAdmin: field.isAdmin
                        };
                    }
                }
                this.renderFieldConstraints(field);
            }, this));
            let fieldCount = _.size(validationTab.fields),
                externalFieldCount = _.size(_.where(validationTab.fields, {
                    isAdmin: false
                }));
            if (fieldCount === 0) {
                validationTab.progress = 100;
                validationTab.saveProgress = 100;
            } else {
                if(externalFieldCount === 0){
                    validationTab.saveProgress = 100;
                } else{
                    validationTab.saveProgress = Math.floor((_.size(_.where(validationTab.fields, {
                        isValid: true,
                        isAdmin: false
                    })) / externalFieldCount) * 100);
                }

                if (this.options.isAdmin) {
                    validationTab.progress = Math.floor((_.size(_.where(validationTab.fields, {
                        isValid: true
                    })) / fieldCount) * 100);
                } else {
                    validationTab.progress = validationTab.saveProgress;
                }
            }
        }, this));
        this.model.completionData.tabs = this.validationData.tabs = _.defaults(this.validationData.tabs, this.model.completionData.tabs ? this.model.completionData.tabs : {});

        let viewTotal = 0,
            saveTotal = 0,
            calcTabCount = 0;
        _.each(this.validationData.tabs, function (tab) {
            if (tab.isCalculate !== false) {
                saveTotal += tab.saveProgress;
                calcTabCount++;
            }
            viewTotal += this.options.isAdmin ? tab.progress : tab.saveProgress;
        }, this);
        this.validationData.progress = Math.floor(viewTotal / _.size(this.validationData.tabs));

        if (inputTab == null) {
            this.initCalculationDone = true;
        }

        let percentComplete = Math.floor(saveTotal / calcTabCount);
        if ((typeof this.initCalculationDone === 'boolean' && this.initCalculationDone) && this.model.get('percentComplete') < 100 && percentComplete >= 100 && this.clients != null && this.clients.hasItems()) {
            let notificationText;
            if (this.model.get('isRequireSignature')) {
                notificationText = 'Please click "Sign and Submit" when you are ready to proceed.  After signing, click "View Requested Criteria" to continue submitting requested items.';
            } else {
                notificationText = 'Please click "View Requested Criteria" when you are ready to proceed.';
            }
            PJQ.notifications.createNotifyModal({
                header: 'Your prequal is 100% complete',
                notification: notificationText,
                cookie: PJQ.constants.cookies.NOTIFY_PREQUAL_VIEW_REQUESTED
            });
        }

        let cData = {
            tabs: _.map(this.model.completionData.tabs, (calc) => {
                return {
                    id: calc.tab.prequalTabId,
                    progress: calc.progress
                };
            })
        };
        this.model.set({
            completionData: cData,
            percentComplete: percentComplete
        });
        this.hideEmptyCategories();
        this.hideEmptyTabs();
        this.renderCompletion(this.validationData);
        this.updateViewScreeningButton();
    },
    validateField: function (tab, field) {
        if (!field.isRequired || field.isValid)
            return true;

        let isValid = false;
        switch (field.fieldType.toLowerCase()) {
            case 'upload':
                isValid = field.fieldValue != null && _.size(field.fieldValue) > 0;
                break;
            case 'int':
            case 'money':
            case 'percent':
                isValid = field.fieldValue != null && !isNaN(parseFloat(field.fieldValue));
                break;
            case 'state':
                isValid = _.size(field.fieldValue) > 0;
                break;
            case 'choice':
                isValid = field.fieldValue != null && ((!isNaN(field.fieldValue) && field.fieldValue > 0) || _.size(field.fieldValue) > 0);
                break;
            case 'text':
            case 'textarea':
            case 'phone':
                isValid = field.fieldValue != null && field.fieldValue.toString().trim().length > 0;

                if (field.coreFieldName.toLowerCase() === 'federaltaxid' && this.model.preferences.hasPref(PJQ.constants.preferenceTypes.PREQUAL_TAX_ID_MASK)) {
                    isValid = field.fieldValue != null && field.fieldValue.toString().trim().length === 9;
                }
                break;
            case 'date':
                isValid = typeof field.fieldValue === 'object' || _.size(field.fieldValue) > 0;
                break;
            case 'bool':
                isValid = (field.fieldValue === true || field.fieldValue === false);
                break;
            case 'grid':
                if (field.coreFieldName.toLowerCase() === 'otheroffices') {
                    isValid = _.size(_.filter(this.model.otherOffices.models, _.bind(function (office) {
                        let row = this.$('div[data-cid=' + office.cid + ']'),
                            isCityValid = office.get('city').trim().length > 0,
                            isStateValid = office.get('stateProvince').length > 0,
                            isZipValid = office.get('postalCode').trim().length > 0;
                        PJQ.helpers.inputHelpers.setInputError(row.find('.other-office-city'), isCityValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('select.other-office-state'), isStateValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('.other-office-zip'), isZipValid);
                        return isCityValid && isStateValid && isZipValid;
                    }, this))) >= 1;

                    let fieldEl = this.getFieldElement(field.prequalFieldId);
                    fieldEl.find('.alert').remove();
                    if (!isValid && this.options.canEdit) {
                        new PJQ.Alert(fieldEl, {
                            type: 'danger',
                            text: 'You must include at least one (1) valid office.',
                            isPrepend: true
                        });
                    }
                } else if (field.coreFieldName.toLowerCase() === 'ownercontacts' || field.coreFieldName.toLowerCase() === 'operationscontacts' || field.coreFieldName.toLowerCase() === 'estimatingcontacts' || field.coreFieldName.toLowerCase() === 'safetycontacts') {
                    let contacts;
                    if (field.coreFieldName.toLowerCase() === 'ownercontacts') {
                        contacts = this.model.ownerContacts;
                    } else if (field.coreFieldName.toLowerCase() === 'operationscontacts') {
                        contacts = this.model.operationsContacts;
                    } else if (field.coreFieldName.toLowerCase() === 'estimatingcontacts') {
                        contacts = this.model.estimatingContacts;
                    } else if (field.coreFieldName.toLowerCase() === 'safetycontacts') {
                        contacts = this.model.safetyContacts;
                    }
                    isValid = _.size(_.filter(contacts.models, _.bind(function (contact) {
                        let row = $('div[data-cid=' + contact.cid + ']'),
                            isContactNameValid = contact.get('contactName').length > 0,
                            isEmailValid = contact.get('email').trim().length > 0,
                            isPhoneValid = contact.get('phone').length > 0;
                        PJQ.helpers.inputHelpers.setInputError(row.find('.contact-name'), isContactNameValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('.contact-email'), isEmailValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('.contact-phone'), isPhoneValid);
                        if (field.coreFieldName.toLowerCase() === 'ownercontacts') {
                            let isTitleValid = contact.get('contactTitle').length > 0;
                            PJQ.helpers.inputHelpers.setInputError(row.find('.contact-title'), isTitleValid);
                            return isContactNameValid && isEmailValid && isPhoneValid && isTitleValid;
                        } else {
                            return isContactNameValid && isEmailValid && isPhoneValid;
                        }
                    }, this))) >= 1;

                    let fieldEl = this.getFieldElement(field.prequalFieldId);
                    fieldEl.find('.alert').remove();
                    if (!isValid && this.options.canEdit) {
                        new PJQ.Alert(fieldEl, {
                            type: 'danger',
                            text: 'You must include at least one (1) valid contact.',
                            isPrepend: true
                        });
                    }
                } else if (field.coreFieldName.toLowerCase() === 'projectreferences') {
                    let projectReferenceRequirementCount = this.model.preferences.hasPref(PJQ.constants.preferenceTypes.PREQUAL_PROJECT_REFERENCE_COUNT) ? this.model.preferences.getPref(PJQ.constants.preferenceTypes.PREQUAL_PROJECT_REFERENCE_COUNT) : 3
                    isValid = _.size(_.filter(this.model.projectReferences.models, function (reference) {
                        return reference.checkIsRecent();
                    })) >= 3;

                    isValid = _.size(_.filter(this.model.projectReferences.models, _.bind(function (reference) {
                        if (!reference.checkIsRecent())
                            return false;

                        let row = $('div[data-cid=' + reference.cid + ']'),
                            isGCValid = reference.get('generalContractor').trim().length > 0,
                            isGCContactValid = reference.get('generalContractorContactName').trim().length > 0,
                            isGCPhoneValid = reference.get('generalContractorContactPhone').trim().length > 0,
                            isProjectNameValid = reference.get('projectName').trim().length > 0,
                            isDateCompletedValid = reference.get('dateCompleted') !== null,
                            isContractValueValid = reference.get('contractValue') > 0;
                        PJQ.helpers.inputHelpers.setInputError(row.find('.project-reference-gc'), isGCValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('.project-reference-gc-contact'), isGCContactValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('.project-reference-gc-phone'), isGCPhoneValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('.project-reference-project-name'), isProjectNameValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('.project-reference-date-completed'), isDateCompletedValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('.project-reference-contract-value'), isContractValueValid);
                        return isGCValid && isGCContactValid && isGCPhoneValid && isProjectNameValid && isDateCompletedValid && isContractValueValid;
                    }, this))) >= projectReferenceRequirementCount;

                    let fieldEl = this.getFieldElement(field.prequalFieldId);
                    fieldEl.find('.alert').remove();
                    if (!isValid && this.options.canEdit) {
                        new PJQ.Alert(fieldEl, {
                            type: 'danger',
                            text: 'You must include at least ' + (PJQ.helpers.formatHelpers.numberToWords(projectReferenceRequirementCount)) + ' (' + (projectReferenceRequirementCount) + ')' +  ' valid references.',
                            isPrepend: true
                        });
                    }
                }
                break;
            case 'groupselect':
                isValid = _.find(this.model.contact.groups.models, function (model) {
                    return model.get('isDeleted') !== true
                }) != null;
                break;
            case 'regionselect':
                isValid = _.size(this.model.contact.workAreas.models) > 0;
                break;
        }
        this.updateFieldValidationState(field, isValid);
        return isValid;
    },
    updateFieldValidationState: function (field, isValid) {
        if (!this.options.canEdit) {
            return;
        }

        let fieldEl = this.getFieldElement(field.prequalFieldId);
        switch (field.fieldType.toLowerCase()) {
            case 'groupselect':
                //todo: show validation error for groups
                break;
            case 'regionselect':
                //todo: show validation error for regions
                break;
            default:
                PJQ.helpers.inputHelpers.setInputError(fieldEl, isValid);
                break;
        }
    },
    renderFieldConstraints: function (field) {
        if (!field.constraints || field.constraints.length === 0)
            return;
        //Loop through all of the fields which are controlled by this field
        _.each(_.where(field.constraints, {controlledByCustomFieldId: field.prequalFieldId}), _.bind(function (control) {
            //We cant loop through the constraints on the controller custom field because the custom field being controlled may have other constraints
            //So instead we check all of the fields which this constraint field relies on
            let controlField = this.model.fields[control.customFieldId],
                fieldContainer = this.getFieldElement(controlField.prequalFieldId).closest('.prequal-field-container');
            if (this.model.checkConstraintsMet(controlField)) {
                fieldContainer.removeClass('hidden');
            } else {
                fieldContainer.addClass('hidden');
            }
            this.validateForm(this.getFieldTab(controlField.prequalFieldId), controlField);
        }, this));
    },
    hideEmptyCategories: function () {
        _.each(this.$('.prequal-category-container'), function (categoryEl) {
            let $category = $(categoryEl);
            if (_.size($category.find('.prequal-field-container:not(.hidden):not(.admin-field)')) === 0) {
                $category.addClass('hidden');
            } else {
                $category.removeClass('hidden');
            }
        });
    },
    hideEmptyTabs: function () {
        _.each(this.$('.prequal-tab'), function (tabEl) {
            let $tab = $(tabEl),
                $menuItem = $('.nav-link[data-nav-tab-id="' + $tab.data('tabId').toString() + '"]');
            if (_.size($tab.find('.prequal-field-container:not(.hidden):not(.admin-field)')) === 0) {
                $menuItem.addClass('hidden');
            } else {
                $menuItem.removeClass('hidden');
            }
        }, this);
    },
    renderCompletion: function (data) {
        _.each(data.tabs, _.bind(function (tabObj) {
            let navItem = this.getTabNavElement(tabObj.tab.prequalTabId);
            navItem.find('.prequal-complete-badge').remove();
            navItem.prepend(this.makeCompletionBadge(tabObj.progress));
        }, this));
        this.$('.prequal-complete-text').remove();

        let colorClass = this.getCompletionColorClass(data.progress);
        if (this.totalProgressBar == null) {
            this.totalProgressBar = new PJQ.progress.ProgressBar(this.$nav.find('.prequal-progress'), {
                isShowPercentage: true,
                height: 25,
                colorClass: colorClass,
                progress: data.progress
            });
        } else {
            this.totalProgressBar.updateProgress(data.progress, colorClass);
        }
    },
    updateLastSavedDate: function () {
        let modifiedOn = this.model.get('modifiedOn');
        if (modifiedOn != null) {
            this.$nav.find('.prequal-last-save').text(PJQ.helpers.dateHelpers.getDateString(new Date(modifiedOn), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME));
            this.$nav.find('.prequal-last-save-container').removeClass('hidden');
        }
    },
    renderTokens: function (input) {
        return PJQ.templating.TemplateRenderer.parseMarkup(input, this.options.tokens);
    },
    makeCompletionBadge: function (percent, includeCompleteText) {
        return $('<span class="badge badge-' + this.getCompletionColorClass(percent) + ' prequal-complete-badge wd-45p fs-14 mr-1">' + percent.toString() + (includeCompleteText ? '% Complete' : '%') + '</span>');
    },
    getTabNavElement: function (tabId) {
        return this.$nav.find('[data-nav-tab-id=' + tabId + ']');
    },
    getTabElement: function (tabId) {
        return this.$('[data-tab-id=' + tabId + ']');
    },
    getCategoryElement: function (tabId, categoryId) {
        return this.getTabElement(tabId).find('[data-field-category-id=' + categoryId + ']')
    },
    getFieldElement: function (fieldId) {
        return this.$('[data-field-id=' + fieldId + ']');
    },
    getFieldTab: function (fieldId) {
        let field = _.findWhere(this.model.fields, {
            prequalFieldId: fieldId
        });
        return field ? _.findWhere(this.model.tabs, {
            prequalTabId: field.prequalTabId
        }) : null;
    },
    getCompletionColorClass: function (percent) {
        let textClass = 'danger';
        if (percent === 100)
            textClass = 'success';
        else if (percent > 60)
            textClass = 'warning';

        return textClass;
    },
    renderGroups: function () {
        if (this.$('.prequal-groups').length > 0) {
            let maxGroups = 10;
            if(this.model.preferences.hasPref(PJQ.constants.preferenceTypes.RESTRICT_GROUP_COUNT)){
                let maxGroupsPref = this.model.preferences.getPref(PJQ.constants.preferenceTypes.RESTRICT_GROUP_COUNT);
                if(maxGroupsPref > 0){
                    maxGroups = maxGroupsPref;
                }
            }
            let groupSelector = new PJQ.views.groups.GroupSelector({
                el: this.$('.prequal-groups'),
                isSync: true,
                groupUserId: this.model.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PREQUAL_PRIVATE_GROUPS) ? this.model.get('masterUserId') : PJQ.constants.publicUserId,
                groupLevels: this.model.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS),
                maxGroups: maxGroups,
                isDisableParents: true,
                selectedGroupIds: this.model.contact.groups.getGroupIds(),
                canEdit: this.options.canEdit,
                isEnableSelectAll: false,
                groupLabel: this.model.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL),
                onGroupSelected: _.bind(function (data) {
                    _.each(data.all, _.bind(function (newGroup) {
                        let existingGroup = this.model.contact.groups.get(newGroup.id),
                            isGroupDeleted = newGroup.get('isDeleted');
                        if (existingGroup) {
                            existingGroup.set('isDeleted', isGroupDeleted);
                        } else if (!existingGroup && !isGroupDeleted) {
                            this.model.contact.groups.add(newGroup);
                        }
                    }, this));

                    let fieldId = this.$('.prequal-groups').data('fieldId');
                    this.queueValidation(this.getFieldTab(fieldId), this.model.fields[fieldId]);
                    this.model.contact.queueSave(null, {
                        success: _.bind(function () {
                            //Remove the deleted groups on successful save so we don't keep sending them
                            // this.model.contact.groups.remove(this.model.contact.groups.where({
                            // 	isDeleted: true
                            // }));
                        }, this)
                    }, 800);
                }, this)
            });
        }
    },
    renderRegions: function () {
        let $regions = this.$('.prequal-regions');
        if (_.size($regions) > 0) {
            this.regionsMap = new PJQ.views.workAreas.WorkAreaMap({
                collection: this.model.contact.workAreas,
                el: $regions,
                contactId: this.model.contact.id,
                isEdit: this.options.canEdit,
                onChange: _.bind(function (obj) {
                    let field = this.model.fields[parseInt(this.$('.prequal-regions').data('fieldId'))];
                    this.queueValidation(this.getFieldTab(field.prequalFieldId), field);
                }, this)
            });
        }
    },
    renderOtherOffices: function (field) {
        _.each(this.model.otherOffices.models, _.bind(function (office) {
            this.renderOtherOffice(field, office);
        }, this));
    },
    renderOtherOffice: function (field, office) {
        let fieldEl = this.getFieldElement(field.prequalFieldId);
        this.renderSubTemplate(true, this.options.subTemplates.otherOffice, fieldEl.find('.grid-items'), {
            field: field,
            item: office,
            isEdit: this.options.canEdit,
            isViewer: false
        }, _.bind(function (content) {
            new PJQ.Binder(content, office, {
                attribute: 'data-c-bind',
                watchElements: [
                    'input'
                ],
                afterChange: _.bind(function (value) {
                    this.prequalChanged(fieldEl, value);
                    office.queueSave({}, {}, 800);
                }, this)
            });

            new PJQ.inputs.Selectpicker({
                el: content.find('.other-office-state'),
                noneSelectedText: 'State',
                defaultValue: office.get('stateProvince'),
                onChange: _.bind(function (value) {
                    this.prequalChanged(fieldEl, value);
                    office.set('stateProvince', value);
                    office.queueSave({}, {}, 800);
                }, this)
            });
        }, this));
    },
    addOtherOffice: function (e) {
        let newOffice = new PJQ.models.prequal.OtherOffice({
            contactId: this.model.contact.id,
            contactCompanyId: this.model.get('contactCompanyId'),
            city: "",
            stateProvince: "",
            postalCode: ""
        });
        this.model.otherOffices.add(newOffice);
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')];
        this.renderOtherOffice(field, newOffice);
        newOffice.save();
        this.queueValidation(this.getFieldTab(field.prequalFieldId), field);
    },
    deleteOtherOffice: function (e) {
        let row = $(e.currentTarget).closest('.grid-item-row'),
            cid = row.data('cid'),
            office = this.model.otherOffices.get(cid);
        office.destroy();
        this.model.otherOffices.remove(office);
        row.remove();
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')],
            tab = this.getFieldTab(field.prequalFieldId);
        this.queueValidation(tab, field);
    },
    renderContactsGrid: function (field, models) {
        _.each(models, _.bind(function (model) {
            this.renderContactsGridItem(field, model);
        }, this));
    },
    renderContactsGridItem: function (field, contact) {
        let fieldEl = this.getFieldElement(field.prequalFieldId);
        this.renderSubTemplate(true, this.options.subTemplates.contact, fieldEl.find('.grid-items'), {
            field: field,
            item: contact,
            isEdit: this.options.canEdit,
        }, _.bind(function (content) {
            new PJQ.Binder(content, contact, {
                attribute: 'data-c-bind',
                watchElements: [
                    'input'
                ],
                afterChange: _.bind(function (value) {
                    this.prequalChanged(fieldEl, value);
                    contact.queueSave({}, {}, 800);
                }, this)
            });

            let acContacts = this.model.getAllPrequalContacts();
            this.renderContactsGridAutocomplete(acContacts, contact);
            PJQ.helpers.inputHelpers.inputMaskPhone(content.find('.input-phone'));
        }, this));
    },
    renderContactsGridsAutocompletes: function () {
        let acContacts = this.model.getAllPrequalContacts();
        _.each(acContacts, function (contact) {
            this.renderContactsGridAutocomplete(acContacts, contact);
        }, this);
    },
    renderContactsGridAutocomplete: function (acContacts, contact) {
        let allContacts = _.filter(acContacts, function (prequalContact) {
                return prequalContact.cid !== contact.cid
            }),
            contactNames = PJQ.helpers.objectHelpers.findDistinct(allContacts, 'contactName');
        if (!this.contactsGridsAutcompletes) {
            this.contactsGridsAutcompletes = [];
        }
        let ac = _.findWhere(this.contactsGridsAutcompletes, {cid: contact.cid}),
            acElement = this.$('.grid-item-row[data-cid=' + contact.cid + ']').find('.contact-name');
        if (acElement.length > 0) {
            if (ac) {
                ac.input.reloadSource({
                    data: contactNames
                });
            } else {
                let acInput = new PJQ.inputs.AutocompleteInput({
                    el: acElement,
                    data: contactNames,
                    dataDisplayProperty: 'contactName',
                    delay: 0,
                    onSelect: _.bind(function (data) {
                        if (data.match) {
                            contact.set({
                                contactName: data.match.get('contactName'),
                                contactTitle: data.match.get('contactTitle'),
                                email: data.match.get('email'),
                                phone: data.match.get('phone')
                            });
                            let row = acInput.$el.closest('.row');
                            row.find('.contact-name').val(contact.get('contactName'));
                            row.find('.contact-title').val(contact.get('contactTitle'));
                            row.find('.contact-email').val(contact.get('email'));
                            row.find('.contact-phone').val(contact.get('phone'));
                            this.prequalChanged(acInput.$el.closest('.prequal-grid'));
                            contact.queueSave({}, {}, 800);
                        }
                    }, this)
                });
                this.contactsGridsAutcompletes.push({
                    cid: contact.cid,
                    input: acInput
                });
            }
        }
    },
    renderOwnerContacts: function (field) {
        this.renderContactsGrid(field, this.model.ownerContacts.models);
    },
    addOwnerContact: function (e) {
        let newContact = new PJQ.models.prequal.OwnerContact({
            contactId: this.model.contact.id,
            contactCompanyId: this.model.get('contactCompanyId'),
            contactName: "",
            contactTitle: "",
            email: "",
            phone: ""
        });
        this.model.ownerContacts.add(newContact);
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')];
        this.renderContactsGridItem(field, newContact);
        newContact.save();
        this.queueValidation(this.getFieldTab(field.prequalFieldId), field);
    },
    deleteOwnerContact: function (e) {
        let row = $(e.currentTarget).closest('.grid-item-row'),
            cid = row.data('cid'),
            contact = this.model.ownerContacts.get(cid);
        contact.destroy();
        this.model.ownerContacts.remove(contact);
        row.remove();
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')],
            tab = this.getFieldTab(field.prequalFieldId);
        this.queueValidation(tab, field);
    },
    renderOperationsContacts: function (field) {
        this.renderContactsGrid(field, this.model.operationsContacts.models);
    },
    addOperationsContact: function (e) {
        let newContact = new PJQ.models.prequal.OperationsContact({
            contactId: this.model.contact.id,
            contactCompanyId: this.model.get('contactCompanyId'),
            contactName: "",
            email: "",
            phone: ""
        });
        this.model.operationsContacts.add(newContact);
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')];
        this.renderContactsGridItem(field, newContact);
        newContact.save();
        this.queueValidation(this.getFieldTab(field.prequalFieldId), field);
    },
    deleteOperationsContact: function (e) {
        let row = $(e.currentTarget).closest('.grid-item-row'),
            cid = row.data('cid'),
            contact = this.model.operationsContacts.get(cid);
        contact.destroy();
        this.model.operationsContacts.remove(contact);
        row.remove();
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')],
            tab = this.getFieldTab(field.prequalFieldId);
        this.queueValidation(tab, field);
    },
    renderEstimatingContacts: function (field) {
        this.renderContactsGrid(field, this.model.estimatingContacts.models);
    },
    addEstimatingContact: function (e) {
        let newContact = new PJQ.models.prequal.EstimatingContact({
            contactId: this.model.contact.id,
            contactCompanyId: this.model.get('contactCompanyId'),
            contactName: "",
            email: "",
            phone: ""
        });
        this.model.estimatingContacts.add(newContact);
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')];
        this.renderContactsGridItem(field, newContact);
        newContact.save();
        this.queueValidation(this.getFieldTab(field.prequalFieldId), field);
    },
    deleteEstimatingContact: function (e) {
        let row = $(e.currentTarget).closest('.grid-item-row'),
            cid = row.data('cid'),
            contact = this.model.estimatingContacts.get(cid);
        contact.destroy();
        this.model.estimatingContacts.remove(contact);
        row.remove();
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')],
            tab = this.getFieldTab(field.prequalFieldId);
        this.queueValidation(tab, field);
    },
    renderSafetyContacts: function (field) {
        this.renderContactsGrid(field, this.model.safetyContacts.models);
    },
    addSafetyContact: function (e) {
        let newContact = new PJQ.models.prequal.SafetyContact({
            contactId: this.model.contact.id,
            contactCompanyId: this.model.get('contactCompanyId'),
            contactName: "",
            email: "",
            phone: ""
        });
        this.model.safetyContacts.add(newContact);
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')];
        this.renderContactsGridItem(field, newContact);
        newContact.save();
        this.queueValidation(this.getFieldTab(field.prequalFieldId), field);
    },
    deleteSafetyContact: function (e) {
        let row = $(e.currentTarget).closest('.grid-item-row'),
            cid = row.data('cid'),
            contact = this.model.safetyContacts.get(cid);
        contact.destroy();
        this.model.safetyContacts.remove(contact);
        row.remove();
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')],
            tab = this.getFieldTab(field.prequalFieldId);
        this.queueValidation(tab, field);
    },
    renderProjectReferences: function (field) {
        _.each(this.model.projectReferences.models, _.bind(function (model) {
            this.renderProjectReference(field, model);
        }, this));
    },
    renderProjectReference: function (field, reference) {
        let fieldEl = this.getFieldElement(field.prequalFieldId);
        this.renderSubTemplate(true, this.options.subTemplates.projectReference, fieldEl.find('.grid-items'), {
            field: field,
            item: reference,
            isEdit: reference.checkIsRecent() && this.options.canEdit,
            isViewer: false
        }, _.bind(function (content) {
            new PJQ.Binder(content, reference, {
                attribute: 'data-c-bind',
                watchElements: [
                    'input'
                ],
                afterChange: _.bind(function (value) {
                    this.prequalChanged(fieldEl);
                    reference.queueSave({}, {}, 800);
                }, this)
            });

            new PJQ.inputs.Datepicker({
                el: content.find('.input-date'),
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.DATE.toUpperCase(),
                    defaultDate: reference.get('dateCompleted')
                },
                onChange: _.bind(function (value) {
                    this.prequalChanged(fieldEl);
                    reference.set('dateCompleted', value);
                    reference.queueSave({}, {}, 800);
                }, this)
            });

            PJQ.helpers.inputHelpers.inputMaskCurrency(content.find('.input-dollars'));
            PJQ.helpers.inputHelpers.inputMaskPhone(content.find('.input-phone'));
        }, this));
    },
    addProjectReference: function (e) {
        let newReference = new PJQ.models.prequal.ProjectReference({
            contactId: this.model.contact.id,
            contactCompanyId: this.model.get('contactCompanyId'),
            generalContractor: "",
            generalContractorContactName: "",
            generalContractorContactPhone: "",
            projectName: "",
            dateCompleted: null,
            contractValue: 0
        });
        this.model.projectReferences.add(newReference);
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')];
        this.renderProjectReference(field, newReference);
        newReference.save();
        this.queueValidation(this.getFieldTab(field.prequalFieldId), field);
    },
    deleteProjectReference: function (e) {
        let row = $(e.currentTarget).closest('.grid-item-row'),
            cid = row.data('cid'),
            reference = this.model.projectReferences.get(cid);
        reference.destroy();
        this.model.projectReferences.remove(reference);
        row.remove();
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')],
            tab = this.getFieldTab(field.prequalFieldId);
        this.queueValidation(tab, field);
    },
    allowZip: function (e) {
        return PJQ.helpers.inputHelpers.allowZip(e);
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e, false, true);
    },
    formatPercent: function (e) {
        $(e.currentTarget).val(PJQ.helpers.formatHelpers.formatPercent($(e.currentTarget).val()));
    },
    networkUpgrade: function () {
        let redirectURL = 'http://network.panteratools.com/pantera-network/?';
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROQUAL_PORTAL))
            redirectURL = 'http://demo.panteratools.com/verified-network-long-video-page/?';
        //todo: load directorysettings from api
        else if (directorySettings.IsNetworkContact && directorySettings.NetworkVerificationLevel == 1)
            redirectURL = 'http://demo.panteratools.com/verified-network-landing-pages-from-pn/?';
        window.open(redirectURL + this.model.contact.id.toString(), '_blank');
    },
    editProfile: function () {
        PJQ.app.router.navigate('profile', {
            trigger: true
        });
    },
    viewFaq: function () {
        let faqItems = this.options.baseFaqItems;
        if (!this.model.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DODGE_CRM) && !this.model.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DODGE_WG))
            faqItems = _.union(faqItems, this.options.proqualFaqItems);
        new PJQ.views.BaseModal({
            header: "Frequently Asked Questions",
            isShowOkButton: false,
            isShowCancelButton: true,
            cancelButtonText: "Close",
            body: PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.faq, {
                faqItems: faqItems
            }).html(),
            okButtonText: "Ok"
        });
    },
    navClicked: function (e) {
        if (this.regionsMap != null && $($(e.target).attr('href')).length > 0)
            this.regionsMap.refresh();

        this.tabChanged();
    },
    lockPrequal: function () {
        if (this.options.isAdmin) {
            this.model.updateLocked(true, _.bind(function () {
                this.render();
                PJQ.notifications.notify.successNotify({
                    message: 'Prequalification Locked'
                });
            }, this));
        }
    },
    unlockPrequal: function () {
        if (this.options.isAdmin) {
            this.model.updateLocked(false, _.bind(function () {
                this.render();
                PJQ.notifications.notify.successNotify({
                    message: 'Prequalification Unlocked'
                });
            }, this));
        }
    },
    previousTab: function () {
        this.changeTab(-1);
    },
    nextTab: function () {
        let currentTabId = parseInt(this.$nav.find('.prequal-nav-item.active').data('navTabId')),
            tabIndex = null;
        _.each(this.model.tabs, function (tab, index) {
            if (tab.prequalTabId === currentTabId)
                tabIndex = index;
        }, this);
        if (this.model.get('isRequireSignature') && tabIndex === this.model.tabs.length - 1) {
            let incompleteTab = _.find(this.model.completionData.tabs, function (tab) {
                return !this.$nav.find('.prequal-nav-item[data-nav-tab-id="' + tab.tab.prequalTabId + '"]').hasClass('hidden') && tab.progress < 100;
            }, this);
            if (incompleteTab == null) {
                this.continue();
            } else {
                this.$nav.find('.prequal-nav-item[data-nav-tab-id="' + incompleteTab.tab.prequalTabId + '"]').tab('show');
                this.tabChanged();
            }
        } else {
            this.changeTab(1);
        }
    },
    changeTab: function (jump) {
        let tabId = parseInt(this.$nav.find('.prequal-nav-item.active').data('navTabId')),
            currentTab = _.findWhere(this.model.tabs, {prequalTabId: tabId}),
            newTab = _.find(_.sortBy(this.model.tabs, function (tab) {
                if (jump < 0) {
                    return -tab.sortOrder;
                }
                return tab.sortOrder;
            }), function (tab) {
                return !this.$nav.find('.prequal-nav-item[data-nav-tab-id="' + tab.prequalTabId + '"]').hasClass('hidden') && ((tab.sortOrder > currentTab.sortOrder && jump > 0) || (tab.sortOrder < currentTab.sortOrder && jump < 0));
            }, this);
        if (newTab != null) {
            this.$nav.find('.prequal-nav-item[data-nav-tab-id="' + newTab.prequalTabId + '"]').tab('show');
            scrollTo(0, 0);
            this.tabChanged();
        }
    },
    tabChanged: function () {
        PJQ.app.scrollTo(0, 0);

        let currentTabId = parseInt(this.$nav.find('.prequal-nav-item.active').data('navTabId')),
            tabIndex = null;
        _.each(this.model.tabs, function (tab, index) {
            if (tab.prequalTabId === currentTabId)
                tabIndex = index;
        }, this);


        if (tabIndex !== this.model.tabs.length - 1) {
            let tab = _.findWhere(this.model.tabs, {
                    prequalTabId: currentTabId
                }),
                nextTab = _.find(this.model.tabs, function (checkTab) {
                    if (checkTab.sortOrder > tab.sortOrder) {
                        return null != _.find(checkTab.fields, function (field) {
                            if (field.isHidden || field.isAdmin && !this.options.isAdmin) {
                                return false;
                            }

                            if (this.options.isAdmin && _.size(field.allowedUserTypeIds) > 0) {
                                return field.allowedUserTypeIds.indexOf(PJQ.app.session.user.get('userTypeId')) !== -1;
                            }

                            return true;
                        }, this);
                    }
                }, this);
            if (nextTab != null) {
                this.$('.prequal-tab-next').removeClass('hidden');
            } else {
                this.$('.prequal-tab-next').addClass('hidden')
            }
        } else
            this.$('.prequal-tab-next').addClass('hidden');
        if (tabIndex > 0)
            this.$('.prequal-tab-previous').removeClass('hidden');
        else
            this.$('.prequal-tab-previous').addClass('hidden');
    },
    downloadFieldFile: function (e) {
        let fieldId = $(e.currentTarget).data('fieldId'),
            field = this.model.fields[fieldId];
        if (_.size(field.defaultValue.trim()) > 0) {
            PJQ.files.downloadFile(field.defaultValue, {
                isEndpoint: false
            });
        } else {
            //todo: show error that the field doesnt have a valid file associated with it
        }
    },
    fillDefaults: function () {
        _.each(_.filter(this.model.fields, _.bind(function (field) {
            return _.size(field.defaultValue) > 0 && ((typeof field.fieldValue === 'string' && _.size(field.fieldValue) === 0) || field.fieldValue == null);
        }, this)), _.bind(function (field) {
            let fieldEl = this.getFieldElement(field.prequalFieldId);
            this.prequalChanged(fieldEl, parseInt(field.defaultValue), field.prequalFieldId, false);
        }, this));
    },
    updateFormulaFields: function () {
        if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'portal', 'customization', 'prequal')) {
            let preventInitCalc = PJQ.app.portal.customization.prequal.preventInitCalc;
            preventInitCalc = preventInitCalc ? preventInitCalc : [];
            _.each(this.formulaFields, _.bind(function (linkedIds, sFieldId) {
                if (_.size(linkedIds) === 0) {
                    return;
                }

                let fieldId = parseInt(sFieldId),
                    field = this.model.fields[fieldId];
                if (field != null && fieldId > 0 && preventInitCalc.indexOf(field.prequalFieldId) === -1) {
                    let fieldEl = this.getFieldElement(fieldId);
                    if (_.size(fieldEl) > 0 && (field.fieldValue > 0 || _.size(field.fieldValue) > 0)) {
                        this.prequalChanged(fieldEl, field.fieldValue, fieldId, false);
                    }
                }
            }, this));
        }
    },
    updateCalcFields: function (changedField) {
        _.each(_.filter(this.model.fields, _.bind(function (field) {
            return field.fieldType.toLowerCase() === 'calc';
        }, this)), _.bind(function (calcField) {
            if (changedField != null) {
                this.updateCalcField(calcField, changedField);
            }
        }, this));
    },
    updateCalcField: function (calcField, changedField) {
        if (_.size(calcField.defaultValue) > 0) {
            let equation = calcField.defaultValue,
                calcFieldsVars = equation.match(/\[(.*?)]/g);
            //If this is for a particular changed field, only recalculate if that field is in the equation
            if (changedField != null && calcFieldsVars.indexOf('[' + changedField.prequalFieldId + ']') === -1)
                return;
            _.each(calcFieldsVars, function (calcFieldVarString) {
                let calcFieldVarId = parseInt(calcFieldVarString.replace(new RegExp(/[\[\]']+/g), '')),
                    calcFieldVar = this.model.fields[calcFieldVarId],
                    calcFieldVarValue = 0;
                if (calcFieldVar != null && (calcFieldVar.fieldType.toLowerCase() === 'int' || calcFieldVar.fieldType.toLowerCase() === 'calc') && _.isNumber(calcFieldVar.fieldValue)) {
                    calcFieldVarValue = calcFieldVar.fieldValue;
                }
                equation = equation.replace(calcFieldVarString, '(' + calcFieldVarValue + ')');
            }, this);
            let solution = math.eval(equation);
            calcField.fieldValue = !_.isNumber(solution) || isNaN(solution) ? 0 : solution;
            let customFields = {};
            customFields[calcField.fieldNumber] = calcField.fieldValue;
            this.model.set('customFieldValues', _.defaults(customFields, this.model.dirtyAttributes.customFieldValues));
            this.getFieldElement(calcField.prequalFieldId).val(calcField.fieldValue);
        }
    }
});